export default {"src":"/_next/static/media/investMenuIcon.a3b97499.svg","height":13,"width":17};